import React from "react"

function Colorado() {
    return (
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80">
            <path d="M85.28 19.040l-0.4-14.72-39.68 0.64-38.88-0.8-2.32 59.12 42.72 0.88 40.64-0.88z"></path>
        </svg>
    )
}

export default Colorado